mutation NoteApprovalCreate($input: NoteApprovalCreateInput!) {
  noteApprovalCreate(input: $input) {
    note {
      id
      noteComment
      _rowTimestamp
      isShared
      entityId
    }
  }
}